import React from 'react'
import API from '../../api';

function Pricing( {user}) {

  const handleCheckout = async (amount, price, name) => {

    try {
      const response = await API.post('/create-checkout-session', {
        userId: user.id,
        amount,
        price,
        name
      })
      console.log(response)
      window.location.href = response.data.url;
    } catch(error) {
      console.log(error)
    }
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] flex flex-col justify-center px-6 sm:px-10 md:px-16 lg:px-24 py-16 bg-[#0D1117] text-[#E6EDF3]">
      {/* Titre principal */}
      <div className="text-center mb-16">
        <h1 className="text-4xl sm:text-5xl font-bold mb-4">
          Choose your <span className="bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] text-transparent bg-clip-text">Token Pack</span> 💎
        </h1>
        <p className="text-[#8B949E] text-lg max-w-2xl mx-auto">
          Get tokens to generate more AI content instantly. Flexible pricing for every creator.
        </p>
      </div>
  
      {/* Grille des plans */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {/* Plan Starter */}
        <div className="bg-[#161B22] border border-[#21262D] rounded-2xl p-8 flex flex-col items-center text-center shadow-[0_0_15px_#3B82F6]/10 hover:shadow-[0_0_25px_#3B82F6]/20 transition-all duration-200">
          <h3 className="text-2xl font-semibold mb-2">Starter</h3>
          <p className="text-[#8B949E] mb-6">
            Perfect for testing your first hooks
          </p>
          <div className="text-4xl font-bold mb-6 text-[#3B82F6]">€5</div>
          <ul className="space-y-3 text-[#8B949E] text-sm mb-8">
            <li>🎯 20 tokens (1 analysis = 1 token)</li>
          </ul>
          <button
            onClick={() => handleCheckout(20, 500, "20 tokens")}
            className="w-full bg-[#3B82F6] hover:bg-[#2563EB] text-white py-3 rounded-lg font-medium transition-all duration-200"
          >
            Get Started
          </button>
        </div>

        {/* Plan Pro - Most Popular */}
        <div className="relative bg-[#161B22] border border-[#3B82F6] rounded-2xl p-8 flex flex-col items-center text-center shadow-[0_0_30px_#3B82F6]/40 hover:shadow-[0_0_40px_#3B82F6]/50 transition-all duration-200 scale-105">
          <div className="absolute -top-4 bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] text-white text-xs font-semibold px-4 py-1 rounded-full shadow-lg">
            MOST POPULAR
          </div>
          <h3 className="text-2xl font-semibold mb-2">Pro</h3>
          <p className="text-[#8B949E] mb-6">
            For creators improving their TikTok performance
          </p>
          <div className="text-4xl font-bold mb-6 text-[#06B6D4]">€10</div>
          <ul className="space-y-3 text-[#8B949E] text-sm mb-8">
            <li>⚡ 50 tokens</li>
          </ul>
          <button
            onClick={() => handleCheckout(50, 1000, "50 tokens")}
            className="w-full bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] hover:opacity-90 text-white py-3 rounded-lg font-medium transition-all duration-200 shadow-[0_0_20px_#3B82F6]/50"
          >
            Buy Now
          </button>
        </div>

        {/* Plan Elite */}
        <div className="bg-[#161B22] border border-[#21262D] rounded-2xl p-8 flex flex-col items-center text-center shadow-[0_0_15px_#3B82F6]/10 hover:shadow-[0_0_25px_#3B82F6]/20 transition-all duration-200">
          <h3 className="text-2xl font-semibold mb-2">Elite</h3>
          <p className="text-[#8B949E] mb-6">
            For agencies & advanced creators optimizing multiple videos
          </p>
          <div className="text-4xl font-bold mb-6 text-[#3B82F6]">€20</div>
          <ul className="space-y-3 text-[#8B949E] text-sm mb-8">
            <li>🚀 120 tokens (best value)</li>
          </ul>
          <button
            onClick={() => handleCheckout(120, 2000, "120 tokens")}
            className="w-full bg-[#3B82F6] hover:bg-[#2563EB] text-white py-3 rounded-lg font-medium transition-all duration-200"
          >
            Upgrade Now
          </button>
        </div>
      </div>

  
      {/* Footer */}
      <p className="text-center text-[#8B949E] text-sm mt-12">
        Need custom volume?{" "}
        <a href="/contact" className="text-[#3B82F6] hover:text-[#06B6D4]">
          Contact us
        </a>
      </p>
    </div>
  );
  
}

export default Pricing